<template>
  <div style="width: 100%; min-height: 100vh; background: #ffffff">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%;background: url(/img/counter/top-bg.webp) no-repeat rgb(8, 76, 203);
    z-index: 1000; color: white;" :title="isEditing ? '编辑收款资料' : '绑定收款方式'" left-arrow @click-left="$router.back()" />
    <div style="height: 46px "></div>
    <div class="usrse">
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">真实姓名</div>
        <div style="flex: 1; margin-left: 10px;">
          <div data-v-a12ec382="" class="van-cell-group van-hairline--top-bottom">
            <div data-v-a12ec382="" class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_owner" placeholder="请输入真实姓名" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="font-size: 0.30rem; color: #3d72fa; text-align: center; box-sizing: border-box; padding: 6px">请填写真实姓名；微信或支付宝可填写账号、上传收款二维码，或两者都填</div>
    <div class="usrse">
      <div class="hgs" v-if="!isEditing" @click="changShow" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">收款方式</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div data-v-a12ec382="" class="van-cell-group van-hairline--top-bottom">
            <div data-v-a12ec382="" class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly v-model="cardInfo.bank" placeholder="请选择收款方式" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">{{ isMobilePayment ? '收款账号（可选）' : '银行卡号/钱包地址' }}</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div data-v-a12ec382="" class="van-cell-group van-hairline--top-bottom">
            <div data-v-a12ec382="" class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" v-model="cardInfo.bank_no" :placeholder="isMobilePayment ? '请输入微信号或支付宝账号' : '请输入银行卡号或钱包地址'" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isMobilePayment" class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">确认姓名</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div data-v-a12ec382="" class="van-cell-group van-hairline--top-bottom">
            <div data-v-a12ec382="" class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_address" placeholder="请输真实姓名" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMobilePayment" class="hgs">
        <div class="nams">收款二维码（可选）</div>
        <input type="file" accept="image/*" @change="uploadQrcode" />
        <div v-if="qrcodePreview || cardInfo.withdraw_qrcode" style="margin-top:10px">
          <img :src="qrcodePreview || qrcodeUrl(cardInfo.withdraw_qrcode_url || cardInfo.withdraw_qrcode)" alt="收款二维码" style="max-width:180px;max-height:180px" />
          <van-button size="mini" type="danger" plain @click="removeQrcode">移除二维码</van-button>
        </div>
      </div>
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">支付密码</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <van-cell-group>
            <van-field v-model="cardInfo.pay_pass" type="password" placeholder="请输入支付密码" />
          </van-cell-group>
        </div>
      </div>
      <van-button type="info" style="margin-top: 20px; width: 100%" @click="bindCard">{{ isEditing ? '保存修改' : '确认添加' }}</van-button>
      <div style="height: 60px"></div>
    </div>
    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" title="收款方式" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'addBankCard',
  data() {
    return {
      cardInfo: {},
      banklist: [],
      show: false,
      qrcodePreview: '',
      cardId: null,
    };
  },
  computed: {
    isEditing() {
      return !!this.cardId;
    },
    isMobilePayment() {
      return ['微信', '支付宝'].includes(this.cardInfo.bank);
    },
  },
  created() {
    const bank = this.$route.query.bank;
    this.cardId = this.$route.query.id || null;
    if (['微信', '支付宝'].includes(bank)) {
      this.$set(this.cardInfo, 'bank', bank);
    }
    if (this.isEditing) this.loadCard();
    this.getBanklist();
  },
  methods: {
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      if (this.cardInfo.bank !== value.bank_name) {
        this.cardInfo.withdraw_qrcode = '';
        this.qrcodePreview = '';
      }
      this.cardInfo.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    getBanklist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            const supported = res.data || [];
            ['微信', '支付宝'].forEach(name => {
              if (!supported.some(item => item.bank_name === name)) {
                supported.push({ bank_name: name });
              }
            });
            that.banklist = supported;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    loadCard() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code === 200) {
          const card = (res.data || []).find(item => String(item.id) === String(this.cardId));
          if (card) {
            this.cardInfo = { ...card, pay_pass: '' };
          } else {
            this.$parent.showTost(0, '收款资料不存在');
          }
        } else {
          this.$parent.showTost(0, res.message || '读取收款资料失败');
        }
        this.$parent.hideLoading();
      }).catch(() => this.$parent.hideLoading());
    },
    qrcodeUrl(path) {
      if (!path) return '';
      if (/^https?:\/\//i.test(path)) return path;
      const baseUrl = sessionStorage.getItem('baseURL') || '';
      return baseUrl.replace(/\/$/, '') + '/uploads/' + String(path).replace(/^\/+/, '');
    },
    removeQrcode() {
      this.cardInfo.withdraw_qrcode = '';
      this.qrcodePreview = '';
    },
    uploadQrcode(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
        this.$parent.showTost(0, '二维码仅支持 JPG、PNG 或 WEBP 图片');
        event.target.value = '';
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$parent.showTost(0, '图片不能超过5MB');
        event.target.value = '';
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('bank', this.cardInfo.bank || this.$route.query.bank || '');
      this.$parent.showLoading();
      this.$apiFun.post('/api/withdraw-qrcode-upload', formData, {
        timeout: 60000,
        headers: { Accept: 'application/json' },
      }).then(res => {
        if (res.code === 200) {
          this.cardInfo.withdraw_qrcode = res.data.path;
          this.qrcodePreview = res.data.url || this.qrcodeUrl(res.data.path);
        } else {
          this.$parent.showTost(0, res.message || '上传失败');
        }
        this.$parent.hideLoading();
        event.target.value = '';
      }).catch(error => {
        this.$parent.hideLoading();
        const response = error && error.response;
        const responseData = response && response.data;
        const validationErrors = responseData && responseData.errors;
        const fileError = validationErrors && validationErrors.file && validationErrors.file[0];
        let message = (responseData && responseData.message) || fileError;
        if (!message && error && error.code === 'ECONNABORTED') {
          message = '上传超时，请切换稳定网络后重试';
        }
        if (!message && response) message = '上传失败（HTTP ' + response.status + '）';
        if (!message) message = '网络连接失败，请检查网络后重试';
        this.$parent.showTost(0, message);
        event.target.value = '';
      });
    },
    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.$parent.showTost(0, '请输入姓名');
        return;
      }
      if (!that.cardInfo.bank) {
        that.$parent.showTost(0, '请选择收款方式');
        return;
      }
      if (that.isMobilePayment) {
        if (!that.cardInfo.bank_no && !that.cardInfo.withdraw_qrcode) {
          that.$parent.showTost(0, '请填写收款账号或上传收款二维码');
          return;
        }
      } else {
        if (!that.cardInfo.bank_address) {
          that.cardInfo.bank_address = that.cardInfo.bank_owner;
        }
        if (!that.cardInfo.bank_address) {
          that.$parent.showTost(0, '请输入开户行/钱包网络信息');
          return;
        }
        if (!that.cardInfo.bank_no) {
          that.$parent.showTost(0, '请输入银行卡号或钱包地址');
          return;
        }
      }
      if (!that.cardInfo.pay_pass) {
        that.$parent.showTost(0, '请输人支付密码');
        return;
      }
      if (!that.isMobilePayment && that.cardInfo.bank_no.length < 8) {
        that.$parent.showTost(0, '请输人正确的长度');
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输人支付密码长度');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            if (that.isEditing && sessionStorage.getItem('withdrawEditSource') === 'withdrawal') {
              sessionStorage.setItem('withdrawUpdatedCard', String(that.cardId));
            }
            sessionStorage.removeItem('withdrawEditSource');
            that.$parent.showTost(1, that.isEditing ? '修改成功' : '绑定成功');
            that.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.usrse {
  background: #fff;
  box-sizing: border-box;
  padding: 6px 20px 0;
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
  }
  .hgs {
    margin-top: 10px;
    margin-bottom: 15px;
    padding: 8px 0;
  }
  .imgsa {
    position: relative;
    height: 2rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.2rem;
    .bisn {
      width: 0.8rem;
      position: absolute;
      bottom: 0.3rem;
      left: 1.4rem;
    }
    img {
      width: 2rem;
      border-radius: 50%;
    }
  }
}
[class*='van-hairline']:after {
  border: none;
}
</style>
<style>
/* 全局样式，确保导航栏标题和返回箭头为白色 */
.van-nav-bar__title {
  color: white !important;
}
.van-icon-arrow-left {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addBankCard.vue